// CartItem.jsx
// Single row in the cart page: image, name, price, quantity stepper, remove button.

import React from "react";
import { useCart } from "../context/CartContext";
import { formatCurrency } from "../utils/pricing";

export default function CartItem({ item }) {
  const { removeFromCart, updateQuantity } = useCart();

  return (
    <div className="flex items-center gap-4 py-4 border-b border-gray-100 last:border-0">
      {/* Product image */}
      <img
        src={item.image}
        alt={item.name}
        className="w-20 h-20 object-cover rounded-xl flex-shrink-0"
        onError={(e) => { e.target.src = "https://via.placeholder.com/80?text=IMG"; }}
      />

      {/* Product info */}
      <div className="flex-1 min-w-0">
        <h4 className="font-semibold text-gray-900 text-sm truncate">{item.name}</h4>
        <p className="text-xs text-gray-500 mb-2">{item.category}</p>

        {/* Quantity stepper */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => updateQuantity(item.id, item.quantity - 1)}
            className="w-7 h-7 flex items-center justify-center rounded-full border border-gray-300 hover:border-red-500 hover:text-red-500 transition-colors text-lg leading-none"
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className="w-6 text-center font-medium text-sm">{item.quantity}</span>
          <button
            onClick={() => updateQuantity(item.id, item.quantity + 1)}
            className="w-7 h-7 flex items-center justify-center rounded-full border border-gray-300 hover:border-red-500 hover:text-red-500 transition-colors text-lg leading-none"
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
      </div>

      {/* Price and remove */}
      <div className="flex flex-col items-end gap-2">
        <span className="font-bold text-red-600 text-base">
          {formatCurrency(item.price * item.quantity)}
        </span>
        <span className="text-xs text-gray-400">{formatCurrency(item.price)} each</span>
        <button
          onClick={() => removeFromCart(item.id)}
          className="text-xs text-gray-400 hover:text-red-500 transition-colors"
          aria-label="Remove item"
        >
          Remove
        </button>
      </div>
    </div>
  );
}
